<template>
    <div class="swiper-slide">
        <slot/>
    </div>
</template>

<script>
export default {
  name: 'swiper-item'
}
</script>

<style lang="scss">
.swiper-slide {
    position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper/swiper-item.vue